import type { ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { Reveal } from './Reveal';

interface SectionHeadingProps {
  eyebrow: string;
  title: ReactNode;
  description?: string;
  align?: 'left' | 'center';
  className?: string;
}

export function SectionHeading({
  eyebrow,
  title,
  description,
  align = 'left',
  className,
}: SectionHeadingProps) {
  const centered = align === 'center';

  return (
    <Reveal className={cn('max-w-3xl', centered && 'mx-auto text-center', className)}>
      <div className={cn('flex items-center gap-3', centered && 'justify-center')}>
        <span className="h-px w-10 bg-nova" aria-hidden="true" />
        <span className="text-xs font-semibold uppercase tracking-[0.35em] text-nova">
          {eyebrow}
        </span>
        {centered && <span className="h-px w-10 bg-nova" aria-hidden="true" />}
      </div>
      <h2 className="mt-5 font-display text-4xl font-bold leading-[1.05] tracking-tight md:text-6xl">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-lg leading-relaxed text-muted-foreground">{description}</p>
      )}
    </Reveal>
  );
}
